import { useState, useEffect } from "react";
import axios from "../../api/axios";
import Flatpickr from "react-flatpickr";
import ResponsiveTable from "../../components/ResponsiveTable";
import "flatpickr/dist/themes/material_blue.css";
import moment from "moment";

export default function ProfitLossReport() {
  const [startDate, setStartDate] = useState(moment().subtract(30, "days").startOf('day').format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().add(1, "days").format("YYYY-MM-DD"));
  const [report, setReport] = useState(null);
  const [invoiceReport, setInvoiceReport] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchReport = async () => {
    setLoading(true);
    try {
      const params = {};
      if (startDate) params.start = moment(startDate).format("YYYY-MM-DD");
      if (endDate) params.end = moment(endDate).format("YYYY-MM-DD");

      const { data } = await axios.get("/reports/profit-loss", { params });
      setReport(data);
    } catch (err) {
      console.error("Failed to load report", err);
    } finally {
      setLoading(false);
    }
  };
  const fetchSalesReport = async () => {
    setLoading(true);
    try {
      const params = {};
      if (startDate) params.start = moment(startDate).format("YYYY-MM-DD");
      if (endDate) params.end = moment(endDate).format("YYYY-MM-DD");

      const { data } = await axios.get("/reports/sales-invoice-profit", { params });
      setInvoiceReport(data);
    } catch (err) {
      console.error("Failed to load report", err);
    } finally {
      setLoading(false);
    }
  };
  const columns = [
    { header: "Invoice No", accessor: "sale_id" },
    {
      header: "Date", accessor: "sale_date",
      render: (value, row) => <span>{moment(value).format("DD/MM/YYYY")}</span>
    },
    { header: "Customer", accessor: "customer_name" },
    { header: "Total Sale", accessor: "sale_total" },
    { header: "Paid", accessor: "paid_amount" },
    { header: "Item Cost", accessor: "total_cost" },
    {
      header: "Profit", accessor: "profit",
      render: (value) => (
        <span className={value >= 0 ? "text-green-700 font-semibold" : "text-red-600"}>
          {Number(value).toFixed(2)} BDT
        </span>
      )
    },
  ];
  useEffect(() => {
    fetchReport();
    fetchSalesReport();
  }, []);

  return (
    <div className="max-w-5xl mx-auto bg-white p-4 rounded shadow text-sm">
      <div className="flex flex-wrap items-end gap-4 mb-4">
        <div>
          <label className="block text-xs mb-1">Start Date</label>
          <Flatpickr
            className="border rounded px-2 py-1 text-sm"
            value={startDate}
            options={{ dateFormat: "Y-m-d" }}
            onChange={(date) => setStartDate(moment(date[0]).format('YYYY-MM-DD'))}
          />
        </div>
        <div>
          <label className="block text-xs mb-1">End Date</label>
          <Flatpickr
            className="border rounded px-2 py-1 text-sm"
            value={endDate}
            options={{ dateFormat: "Y-m-d" }}
            onChange={(date) => setEndDate(moment(date[0]).format('YYYY-MM-DD'))}
          />
        </div>
        <button
          onClick={() => {
            fetchReport()
            fetchSalesReport()
          }
          }
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm"
        >
          {loading ? "Loading..." : "Generate Report"}
        </button>
      </div>

      {report && (
        <div className="grid md:grid-cols-2 gap-6">
          {/* Date Range Summary */}
          <div className="bg-blue-50 p-4 rounded border">
            <h2 className="font-semibold mb-2 text-blue-800">Date-Range Summary</h2>
            <ul className="space-y-1">
              <li>Total Sales: <strong>{report.date_range.total_sales.toFixed(2)} BDT</strong></li>
              <li>Total Purchases: <strong>{report.date_range.total_purchases.toFixed(2)} BDT</strong></li>
              <li>Total Expenses: <strong>{report.date_range.total_expenses.toFixed(2)} BDT</strong></li>
              <li>Gross Profit: <strong className="text-blue-700">{report.date_range.gross_profit.toFixed(2)} BDT</strong></li>
              <li>Net Profit: <strong className={report.date_range.net_profit >= 0 ? "text-green-700" : "text-red-700"}>
                {report.date_range.net_profit.toFixed(2)} BDT
              </strong></li>
            </ul>
          </div>

          {/* Lifetime Summary */}
          <div className="bg-green-50 p-4 rounded border">
            <h2 className="font-semibold mb-2 text-green-800">Lifetime Summary</h2>
            <ul className="space-y-1">
              <li>Total Sales: <strong>{report.lifetime.total_sales.toFixed(2)} BDT</strong></li>
              <li>Total Purchases: <strong>{report.lifetime.total_purchases.toFixed(2)} BDT</strong></li>
              <li>Total Expenses: <strong>{report.lifetime.total_expenses.toFixed(2)} BDT</strong></li>
              <li>Gross Profit: <strong className="text-blue-700">{report.lifetime.gross_profit.toFixed(2)} BDT</strong></li>
              <li>Net Profit: <strong className={report.lifetime.net_profit >= 0 ? "text-green-700" : "text-red-700"}>
                {report.lifetime.net_profit.toFixed(2)} BDT
              </strong></li>
            </ul>
          </div>

        </div>
      )}
      <h2 className=" font-semibold my-3 text-lg px-2">Invoice wise Profit List</h2>
      <hr />
      <ResponsiveTable
        columns={columns}
        data={invoiceReport}
        showActions={false}
      />
    </div>
  );
}
